import style from "styled-components";
import { Link } from "react-router-dom";

export const HeaderContainer = style.div`
    background-color:white;
    color:black;
    display:flex;
    flex-direction:row; 
    justify-content:space-around;
    border:1px solid black;
`;

export const HeaderMenuList = style.ul`
   list-style:none;
   display:grid;
   margin-top:2.0rem;
   grid-template-columns:repeat(4,auto);
   grid-gap:2rem;
   @media(max-width:800px){
    display:none;
  }
`;

export const MenuListItem = style(Link)`
text-decoration:none;
color:black;
 cursor: pointer;
 &:hover{
     outline:none;
 }
 &:focus{
     outline:none;
 }
`;

export const HeaderOptions = style.div`
 display: flex;
    flex-direction: row;
    gap: 1rem;
     @media(max-width:800px){
    display:none;
  }
`;

export const OptionSearch = style.img`
   max-width: 1rem;
    cursor: pointer;
`;
